import MuiDialogActions, {
  DialogActionsProps,
} from "@mui/material/DialogActions";

const DialogActions: React.FC<DialogActionsProps> = MuiDialogActions;

export default DialogActions;
export type { DialogActionsProps };
